import { ReportHandler } from 'web-vitals';

import { trackWebVital } from './services/analyticsService';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export const sendWebVitalsToAnalytics: ReportHandler = (metric) => {
  trackWebVital({
    name: metric.name,
    value: metric.value,
    id: metric.id,
  });
};

export default reportWebVitals;
